import { render, staticRenderFns } from "./auctionResult.vue?vue&type=template&id=0d6d87bd&scoped=true&"
import script from "./auctionResult.vue?vue&type=script&lang=js&"
export * from "./auctionResult.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./auctionResult.vue?vue&type=style&index=0&id=0d6d87bd&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0d6d87bd",
  "26bda368"
  
)

export default component.exports